// Dev-only logger: surfaces errors during local development without leaking
// implementation details to end users in production builds.
export const devError = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.error(...args);
  }
};
